import "./LabReportDetailsViewComponent.scss";
import ButtonComponent from "../../../../../shared/components/core/button/ButtonComponent";
import EditIcon from "@mui/icons-material/Edit";
import {Grid} from "@mui/material";
import React, {useEffect} from "react";
import AttachmentViewDownloadComponent
    from "../../../../../shared/components/core/attachment-view-download/attachmentViewDownloadComponent";
import ColorPickerComponent from "../../../../../shared/components/color-picker/ColorPickerComponent";
import commonService from "../../../../../shared/services/common.service";
import DetailsDataKeyValueComponent
    from "../../../../../shared/components/details-data-key-value-component/detailsDataKeyValueComponent";

interface LabReportDetailsViewComponentProps {
    labDetails: any;
    canEdit: boolean;
    onEditModeOpen: any;
}

const LabReportDetailsViewComponent = (props: LabReportDetailsViewComponentProps) => {
    const {labDetails, canEdit, onEditModeOpen} = props;
    const [themeColor, setThemeColor] = React.useState({
        r: '241',
        g: '112',
        b: '19',
        a: '1',
    });

    useEffect(() => {
        if (labDetails) {
            setThemeColor(commonService.hexToRgba(labDetails?.themeColor));
        }
    }, [labDetails]);

    return (
        <div className={'lab-report-details-view-component details-tab-data-content'}>
            <>
                <div className="details-tab-data-header">
                    <div className="view-and-edit-title">Report Setup</div>
                    {canEdit &&
                        <div className="">
                            <ButtonComponent
                                className={"white-space-nowrap"}
                                type="button"
                                color={"primary"}
                                variant={"outlined"}
                                startIcon={<EditIcon/>}
                                fullWidth={true}
                                handleClick={onEditModeOpen}
                            >
                                Edit Details
                            </ButtonComponent>
                        </div>
                    }
                </div>
                <div className="details-tab-data-body">
                    <Grid container spacing={2} className="pdd-top-20">
                        <Grid item xs={12} sm={12} md={6} xl={6}>
                            <DetailsDataKeyValueComponent title={"Logo"}>
                            {
                                labDetails?.logo ? <AttachmentViewDownloadComponent attachment={labDetails?.logo}
                                                                                    attachmentTitle={"Lab_logo"}/> :
                                    "NA"
                            }
                            </DetailsDataKeyValueComponent>
                        </Grid>
                        <Grid item xs={12} sm={12} md={6} xl={6}>
                            <DetailsDataKeyValueComponent title={"Theme Color"}>
                                <ColorPickerComponent
                                    canEdit={false}
                                    themeColor={themeColor}
                                />
                            </DetailsDataKeyValueComponent>
                        </Grid>
                    </Grid>
                </div>
            </>
        </div>
    );

};

export default LabReportDetailsViewComponent;
